@if (control) {
  <div class="password-validation">
    <div
      class="password-validation__item"
      [ngClass]="
        control.hasError('required') || control.hasError('minlength')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <fa-icon
        [icon]="
          control.hasError('required') || control.hasError('minlength')
            ? uncheckIcon
            : checkIcon
        "
      ></fa-icon>
      <span>{{ 'PASSWORD_CONDITION_LENGTH' | translate }}</span>
    </div>
    <div
      class="password-validation__item"
      [ngClass]="
        control.hasError('required') || control.hasError('hasNumber')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <fa-icon
        [icon]="
          control.hasError('required') || control.hasError('hasNumber')
            ? uncheckIcon
            : checkIcon
        "
      ></fa-icon>
      <span>{{ 'PASSWORD_CONDITION_DIGIT' | translate }}</span>
    </div>
    <div
      class="password-validation__item"
      [ngClass]="
        control.hasError('required') || control.hasError('hasCapitalCase')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <fa-icon
        [icon]="
          control.hasError('required') || control.hasError('hasCapitalCase')
            ? uncheckIcon
            : checkIcon
        "
      ></fa-icon>
      <span>{{ 'PASSWORD_CONDITION_UPPERCASE' | translate }}</span>
    </div>
    <div
      class="password-validation__item"
      [ngClass]="
        control.hasError('required') || control.hasError('hasSmallCase')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <fa-icon
        [icon]="
          control.hasError('required') || control.hasError('hasSmallCase')
            ? uncheckIcon
            : checkIcon
        "
      ></fa-icon>
      <span>{{ 'PASSWORD_CONDITION_LOWERCASE' | translate }}</span>
    </div>
  </div>
}
